class Scaler {
    constructor(min, max) {
        this.minValue = min;
        this.maxValue = min;
        this.min = min;
        this.max = max;
    }

    set min(min) {
        if (min === '-') {
            this.minValue = -0.0;
        } else {
            this.minValue = parseFloat(min);
        }
    }

    set max(max) {
        if (max=== '-') {
            this.maxValue = -0.0;
        } else {
            this.maxValue = parseFloat(max);
        }
    }

    get min() {
        return this.minValue;
    }

    get max() {
        return this.maxValue;
    }
}

export default Scaler;
